import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as RecipeId } from '../../../../whole-house/recipe/Id';

export const Request = intersect(
	struct({
		organizationId: OrganizationId,
	})
)(
	partial({
		recipeId: RecipeId,
	})
);
